import { render, staticRenderFns } from "./Responsables.vue?vue&type=template&id=63605576&scoped=true"
import script from "./Responsables.vue?vue&type=script&lang=js"
export * from "./Responsables.vue?vue&type=script&lang=js"
import style0 from "./Responsables.vue?vue&type=style&index=0&id=63605576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63605576",
  null
  
)

export default component.exports